export default __webpack_public_path__ + "scripts/resource/f83fb2881bf9c86b433ca643866606e0.svg";